import { IonItemDivider, IonLabel } from "@ionic/react";
import { useSelector } from "react-redux";

import { selectFileTypes } from "../../../store/fileTypes/selectors/selectFileTypes";
import { FileTypesListItem } from "./FileTypesListItem";


export const FileTypesListContainer = () => {
  const fileTypesList = useSelector(selectFileTypes);
  return (
    <>
      <IonItemDivider class="ion-margin-bottom">
        <IonLabel>
          <p>{fileTypesList.length} resultados</p>
        </IonLabel>
      </IonItemDivider>
      {fileTypesList.map((category) => (
        <FileTypesListItem key={category.id} category={category} />
      ))}
    </>
  );
};
